import React from 'react'
import axios from 'axios'
import './footer.css';

export default React.createClass({
  getInitialState: function () {
    return {
      weekday: '6:00AM - 7PM',
      sat: '7:00AM - 5:30PM',
      sun: '7:00AM - 3:30PM',
      zone: 'MST',
      year: new Date().getFullYear()
    }
  },
  componentWillMount: function () {
    const thisElement = this
    axios.get('/hours-of-operation')
      .then(function (response) {
        thisElement.setState({
          weekday: response.data.WEEKDAY_OPERATING_HOURS,
          sat: response.data.SATURDAY_OPERATING_HOURS,
          sun: response.data.SUNDAY_OPERATING_HOURS,
          zone: response.data.OPERATING_HOURS_TIME_ZONE
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  },

  render: function () {
    return (
      <div>
        <footer id="new-footer" className="container-fluid brand-cancel-background white-color">
          <div className="row">
            <div className="col-md-12 col-lg-2 logo-container">
              <a href="/">
                <img src='../../../common/latest/images/te-white-logo.svg' alt="TaskEasy Logo" itemProp="logo"
                  className="footer-logo-white" />
              </a>
            </div>
            <div className="col-xs-12 col-sm-9 col-lg-7 nav-holder">
              <div className="col-xs-12 col-sm-5 col-md-6 footer-nav-list">
                <h5>yard care services</h5>
                <div className="footer-nav-container">
                  <nav><a href="/business/propertymanagers">For Businesses</a></nav>
                  <nav><a href="/lawnmowing">For Homeowners</a></nav>
                  <nav><a href="/contractors">Become a TaskEasy Contractor</a></nav>
                </div>
              </div>
              <div className="col-xs-12 col-sm-3 col-md-3 footer-nav-list middle">
                <h5>company</h5>
                <div className="footer-nav-container">
                  <nav><a href="/company/about">About Us</a></nav>
                  <nav><a href="/company/investors">Our Investors</a></nav>
                  <nav><a href="/company/newsroom">Newsroom</a></nav>
                  <nav><a href="/company/careers">Careers</a></nav>
                </div>
              </div>
              <div className="col-xs-12 col-sm-3 col-md-3 footer-nav-list">
                <h5>connect</h5>
                <div className="footer-nav-container">
                  <nav><a href="/company/faq">FAQ</a></nav>
                  <nav><a href="/company/contact">Contact Us</a></nav>
                  <nav><a href="/blog">Blog</a></nav>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-lg-3 footer-social-info">
              <div>
                <a href="https://www.linkedin.com/company/taskeasy/" title="TaskEasy on Linkedin" target="_blank">
                  <i className="fa fa-linkedin fa-2x white-color"></i>
                </a>
                <a href="http://www.twitter.com/taskeasy/" title="TaskEasy on Twitter" target="_blank">
                  <i className="fa fa-twitter fa-2x  white-color"></i>
                </a>
                <a href="http://www.facebook.com/taskeasy/" title="TaskEasy on Facebook" target="_blank">
                  <i className="fa fa-facebook fa-2x white-color"></i>
                </a>
              </div>
              <h5 className="phone"><a href="tel:+8015184461">1.800.518.4461</a></h5>
              <div className="open-hours">M-F {this.state.weekday} {this.state.zone}</div>
              <div className="open-hours">Saturday {this.state.sat}</div>
              <div className="open-hours">Sunday {this.state.sun}</div>
            </div>
          </div>
          <div className="row copyright-info">
            <div className="copyright-years">
              TaskEasy &reg; 2011-{this.state.year} All Rights Reserved </div>
            <div>
              <a href="/company/privacy">Privacy Policy</a>
              <a href="/company/terms">Terms of Use</a>
              <a target="blank" href="https://privacyportal-cdn.onetrust.com/dsarwebform/5f7c621d-52d1-4748-8cb0-53f4996d5c1f/3325e2a3-6ae2-489c-80f0-9229c5525237.html">CCPA Requests</a>
            </div>
          </div>
        </footer>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/shared/footer.jsx